// extracted by mini-css-extract-plugin
export default {"container":"StepsSection_container__qRSQY","body":"StepsSection_body__2Hwdl","steps":"StepsSection_steps__ghNI8","title":"StepsSection_title__2JMAM"};